// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__jTlRg","single2":"loader_single2__nUzUy","small":"loader_small__Fd17T","medium":"loader_medium__WToL6","large":"loader_large__wrPIF"};